import { render, staticRenderFns } from "./AddRemoveItem.vue?vue&type=template&id=91c46566&scoped=true"
import script from "./AddRemoveItem.vue?vue&type=script&lang=js"
export * from "./AddRemoveItem.vue?vue&type=script&lang=js"
import style0 from "./AddRemoveItem.vue?vue&type=style&index=0&id=91c46566&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91c46566",
  null
  
)

export default component.exports